"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceVariableInstructions = exports.isNamespaced = exports.extractInstruction = void 0;
var api_instruction_1 = require("./api-instruction");
Object.defineProperty(exports, "extractInstruction", { enumerable: true, get: function () { return api_instruction_1.extractInstruction; } });
var instruction_1 = require("./instruction");
Object.defineProperty(exports, "isNamespaced", { enumerable: true, get: function () { return instruction_1.isNamespaced; } });
var reduce_variable_instructions_1 = require("./reduce-variable-instructions");
Object.defineProperty(exports, "reduceVariableInstructions", { enumerable: true, get: function () { return reduce_variable_instructions_1.reduceVariableInstructions; } });
